var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 45,
    viewBox: "0 0 100 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 12.2324H42.7439C43.6717 12.2324 44.3891 12.4429 44.8959 12.8639C45.405 13.2827 45.7486 13.8722 45.9269 14.6336C46.1041 15.3929 46.1932 16.3604 46.1932 17.5374C46.1932 18.6145 46.0525 19.4554 45.7722 20.0589C45.4909 20.6635 45.0044 21.0844 44.3117 21.3218C44.8873 21.4399 45.304 21.7277 45.5617 22.1852C45.8195 22.6405 45.9483 23.2591 45.9483 24.0408L45.9054 31.2273H42.1898V23.796C42.1898 23.2666 42.0867 22.9283 41.8805 22.7823C41.6743 22.6341 41.2974 22.5589 40.7508 22.5589V31.2273H36.9062V12.2324ZM41.6829 19.2642C42.2123 19.2642 42.4776 18.6886 42.4776 17.5374C42.4776 17.037 42.4539 16.6611 42.4088 16.412C42.3659 16.1607 42.2853 15.9867 42.1683 15.8922C42.0502 15.7956 41.8805 15.7462 41.6571 15.7462H40.7765V19.2642H41.6829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2734 31.2273V12.2324H50.9461V31.2273H47.2734Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9795 31.2273V27.778L56.3137 15.7247H52.4005V12.2324H60.3386V15.5486L55.897 27.735H60.141V31.2273H51.9795Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0508 31.2273V27.778L65.385 15.7247H61.4717V12.2324H69.4099V15.5486L64.9683 27.735H69.2123V31.2273H61.0508Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5379 31.1338V15.7601H70.2773V12.11H78.6064V15.7601H76.3459V31.1338H72.5379ZM79.4923 31.1338V12.11H83.1693V31.1338H79.4923ZM84.1412 31.1338L86.1805 21.0328L84.5632 12.082H88.2842L89.284 18.6424L90.1442 12.082H93.8867L92.2479 21.0328L94.2862 31.1338H90.4363L89.2357 23.6929L88.019 31.1338H84.1412Z",
    stroke: "white",
    strokeWidth: 0.636883
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 6.23438H25.2578V6.89911H8.60938V6.23438Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 7.23438H25.2578V7.5662H8.60938V7.23438Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 8.23242H25.2578V8.56533H8.60938V8.23242Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 9.89648H25.2578V10.2294H8.60938V9.89648Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 10.8984H25.2578V11.8982H8.60938V10.8984Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 12.2266H25.2578V12.8913H8.60938V12.2266Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 13.5586H25.2578V14.2233H8.60938V13.5586Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 14.5586H25.2578V15.2233H8.60938V14.5586Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 15.8887H25.2578V16.5534H8.60938V15.8887Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 17.2207H25.2578V17.8854H8.60938V17.2207Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 18.5547H25.2578V18.8876H8.60938V18.5547Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 19.2188H25.2578V20.2185H8.60938V19.2188Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 20.8828H25.2578V21.2157H8.60938V20.8828Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 21.5508H25.2578V22.5506H8.60938V21.5508Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 22.8789H25.2578V24.2116H8.60938V22.8789Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 24.543H25.2578V25.5438H8.60938V24.543Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 25.877H25.2578V26.2099H8.60938V25.877Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 27.2109H25.2578V27.8757H8.60938V27.2109Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 28.207H25.2578V28.5389H8.60938V28.207Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 28.875H25.2578V29.8748H8.60938V28.875Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 30.207H25.2578V30.8718H8.60938V30.207Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 31.8711H25.2578V32.204H8.60938V31.8711Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 32.5352H25.2578V33.8678H8.60938V32.5352Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 34.2012H25.2578V35.201H8.60938V34.2012Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 35.5332H25.2578V36.1979H8.60938V35.5332Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 36.5312H25.2578V37.196H8.60938V36.5312Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 37.8633H25.2578V38.528H8.60938V37.8633Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 39.1953H25.2578V39.86H8.60938V39.1953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5103_646847",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 45
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0253906H100V44.9738H0V0.0253906Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5103_646847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9463 44.9322H0.0751953V39.4886H0.5273C2.02859 39.4886 3.25067 38.2666 3.25067 36.7653C3.25067 35.264 2.02859 34.0419 0.5273 34.0419H0.0751953V29.9665H0.5273C2.02859 29.9665 3.25067 28.7444 3.25067 27.2432C3.25067 25.7419 2.02859 24.5198 0.5273 24.5198H0.0751953V20.4347H0.5273C2.02859 20.4347 3.25067 19.2137 3.25067 17.7124C3.25067 16.2101 2.02859 14.9891 0.5273 14.9891H0.0751953V10.9126H0.5273C2.02859 10.9126 3.25067 9.69161 3.25067 8.18925C3.25067 6.68796 2.02859 5.46695 0.5273 5.46695H0.0751953V0.0234375H99.9463V5.46695H99.4942C97.9929 5.46695 96.7709 6.68796 96.7709 8.18925C96.7709 9.69161 97.9929 10.9126 99.4942 10.9126H99.9463V14.9891H99.4942C97.9929 14.9891 96.7709 16.2101 96.7709 17.7124C96.7709 19.2137 97.9929 20.4347 99.4942 20.4347H99.9463V24.5112H99.4942C97.9929 24.5112 96.7709 25.7322 96.7709 27.2346C96.7709 28.7359 97.9929 29.9579 99.4942 29.9579H99.9463V34.0333H99.4942C97.9929 34.0333 96.7709 35.2554 96.7709 36.7567C96.7709 38.258 97.9929 39.4801 99.4942 39.4801H99.9463V44.9322ZM0.979405 44.0312H99.0453V40.3628C97.2584 40.1416 95.8699 38.6113 95.8699 36.7653C95.8699 34.9193 97.2584 33.389 99.0453 33.1678V30.8374C97.2584 30.6162 95.8699 29.0859 95.8699 27.2399C95.8699 25.395 97.2584 23.8636 99.0453 23.6424V21.31C97.2584 21.0877 95.8699 19.5574 95.8699 17.7124C95.8699 15.8664 97.2584 14.3362 99.0453 14.1139V11.7846C97.2584 11.5634 95.8699 10.032 95.8699 8.1871C95.8699 6.34109 97.2584 4.81081 99.0453 4.58852V0.921204H0.979405V4.58852C2.76635 4.81081 4.15488 6.34109 4.15488 8.1871C4.15488 10.032 2.76635 11.5634 0.979405 11.7846V14.1139C2.76635 14.3362 4.15488 15.8664 4.15488 17.7124C4.15488 19.5574 2.76635 21.0877 0.979405 21.31V23.6392C2.76635 23.8604 4.15488 25.3918 4.15488 27.2367C4.15488 29.0827 2.76635 30.613 0.979405 30.8353V33.1646C2.76635 33.3858 4.15488 34.9171 4.15488 36.7621C4.15488 38.6081 2.76635 40.1383 0.979405 40.3606V44.0312Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7969 0.466797H31.6979V44.3403H30.7969V0.466797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.069f14c0ee8f92abb68af8b8f78ae878.svg";
export { ForwardRef as ReactComponent };